import { Text, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { ResponsesFundResponse, ResponsesPeriodResponse } from '@genial/services/dist/models';
import React, { useState } from 'react';

import { messageError } from '../../../../Table/constants';
import { DetailsIRRateTable } from '../DetailsIRRateTable';
import { DetailsProfitablityPeriodTable } from '../DetailsProfitablityPeriodTable';
import { DetailsStatementsTable } from '../DetailsStatementsTable';
import { Header } from '../Header';

interface FundPensionItemProps {
  item: ResponsesFundResponse;
}

export const FundPensionItem: React.FC<FundPensionItemProps> = ({ item }) => {
  const [isOpened, setIsOpened] = useState(false);

  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Header
        handleOpenInfo={() => setIsOpened((state) => !state)}
        isOpened={isOpened}
        title={item?.name || messageError}
      />
      {isOpened && (
        <VStack space={Spacing['inline.xxxs']}>
          <DetailsStatementsTable data={item?.balances || []} />
          <DetailsIRRateTable data={item?.reserve?.reservesAliquotes || []} />
          <DetailsProfitablityPeriodTable
            data={item?.profitability?.period || ({} as ResponsesPeriodResponse)}
          />
          <Text color={'neutral.dark'} fontSize={Typography['fontsize.xs']} variant="regular">
            {item?.profitability?.observation || messageError}
          </Text>
        </VStack>
      )}
    </VStack>
  );
};
